import styled, { css } from 'styled-components';
import { layout, remCalc, colors } from '@prisjakt/ui-base';

type RowProps = {
  removed: boolean;
};

export const Row = styled.div<RowProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #cfcfcf;
  border-radius: 5px;
  margin-bottom: 10px;
  margin-right: 10px;
  padding: 0 10px;

  ${props =>
    props.removed &&
    css`
      background-color: #efefef;
    `}
`;

export const Image = styled.img`
  height: 50px;
  margin-right: 20px;
`;

export const Toggle = styled.div`
  height: 2em;

  input {
    display: none;

    &,
    &:after,
    &:before,
    & *,
    & *:after,
    & *:before,
    & + label {
      box-sizing: border-box;
      &::selection {
        background: none;
      }
    }

    + label {
      outline: 0;
      display: block;
      width: 4em;
      height: 2em;
      position: relative;
      cursor: pointer;
      user-select: none;

      background: #f0f0f0;
      border-radius: 2em;
      padding: 2px;
      transition: all 0.4s ease;

      &:after,
      &:before {
        position: relative;
        display: block;
        content: '';
        width: 50%;
        height: 100%;
      }

      &:after {
        left: 0;
        border-radius: 50%;
        background: #fff;
        transition: all 0.2s ease;
      }

      &:before {
        display: none;
      }
    }

    &:checked + label:after {
      left: 50%;
    }

    &:checked + label {
      background: #15729a;
    }
  }
`;

type TrackingSettingProps = {
  indent?: boolean;
  disabled?: boolean;
};

export const TrackingSetting = styled.div<TrackingSettingProps>`
  margin-left: ${props => (props.indent ? '50px' : '0')};
  margin-bottom: ${remCalc(16)};
  padding: 0 ${layout.pageContent.gutter.rem};
`;

export const TrackingSettingLabel = styled.span<TrackingSettingProps>`
  color: ${colors.darkBlue1};
  font-weight: 700;
`;
